import { PetType } from 'constants/pet-type';

export const toOldPetType = (petType: PetType): 'dogs' | 'cats' =>
  petType === PetType.Dog ? 'dogs' : 'cats';
